<template>
  <div>
    <img src="../assets/images/jakob_sw_mobile.jpeg" class="w-100" alt="" />
    <div class="text-body text-center mx-auto pt-5">
      <h1 class="header-title pb-1">Jakob</h1>
      <h2 style="color: rgb(185, 185, 185)" class="fw-normal pb-5 fs-3">
        Gründer von Voice Art Productions
      </h2>

      <div class="text-start pb-5 px-3">
        <p lang="de" class="text-white px-3 fs-5 fw-lighter bio">
          Als echter Berliner, mit echt vielen Geschwistern und echtem Interesse
          an den Dingen, die er macht, ist ihm wichtig, dass seine Arbeit mit
          den Kund*innen und seine Projekte genauso echt bleiben wie die
          Geschichten dahinter und die Menschen, die sie erzählen. Denn Jakob
          steht voll und ganz hinter den Dingen: In der Schule noch hinterher,
          seit der Jugend hinter internationalen DJ-Pults, das BWL-Studium
          hinterher nochmal kritisch hinterfragt,
        </p>

        <p lang="de" class="text-white px-3 fs-5 fw-lighter bio">
          daraufhin mit Leidenschaft und Präzision hinter seinem Musikstudium.
          Am Wochenende hinter seiner Fußballmannschaft und hinter dem von ihm
          (und seinen Freunden!) geliebten Pizzaofen. Vom Musiker, Produzenten
          und DJ aus dem Rampenlicht immer mehr hinter die Kulissen und als
          Soundengineer mit viel Liebe hinter jedem einzelnen Projekt. Nicht
          geradlinig, aber echt!
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-body {
  background-color: black;
}
.parallax-curtain {
  height: 70vh;
  background: rgba(0, 0, 0, 0.85);
}
</style>
